<template>
  <div v-if="active">
    <section class="navbar-container" :class="{'hidden-mobile' : hiddenMobile}">

      <!-- Navbar -->
      <nav class="navbar">
        <div class="navbar-brand is-hidden-desktop">

          <!-- Category Burger -->
          <span v-if="$isEngCom" class="navbar-item is-flex explore-button gtm-nav-burger" @click="toggleExplore">
            <div v-if="!isExploring" class="explore icon is-small"><i class="fa fa-bars gtm-nav-burger"></i></div>
            <div v-if="isExploring" class="explore icon is-small"><i class="far fa-times"></i></div>
          </span>
          <!-- Start Now Mobile -->
          <div v-if="showStartButton" class="navbar-item" :class="{'small-start' : showBackButton}">
            <div v-if="!isSearching" class="navbar-item button is-small start-now gtm-nav-start-now" @click="startNow">
              <span><i class="far fa-plus"></i></span>
            </div>
          </div>

        </div>
        <div class="navbar-menu is-shadowless" :class="{'is-active': showMenu}">
          <div class="navbar-start is-hidden-touch">
            <!-- Start Now Desktop -->
            <div v-if="!isSearching && showStartButton" class="navbar-item gtm-nav-dropdown">
              <a class="start-now gtm-nav-start-now button is-small" @click="startNow">
                <span><i class="far fa-plus"></i> Start</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </section>
    <div class="navbar-spacer" :class="{'hidden-mobile' : !active}"></div>
    <notifications></notifications>

    <explore @toggleExplore="toggleExplore" :isExploring="isExploring"></explore>
    <login-modal ref="loginModal"></login-modal>
    <source-modal v-if="!$isEngCom && isLoggedIn" ref="sourceModal"></source-modal>
    <feedback-modal v-if="$isEngCom"></feedback-modal>
    <categories-modal></categories-modal>
    <logout v-if="showLogout" @cancel="showLogout = false" @logout="logout"></logout>
  </div>
</template>

<script>
import Explore from '../Base/NavToolbar/ExploreDropdown'

import socket from '@/libs/socket'
import imageProxy from '@/libs/image-proxy'
import versionCheck from '@/libs/version-check'
import Notifications from '@/components/Controls/Notifications'
import LoginModal from '@/components/Modals/Login'
import SourceModal from '@/components/Modals/SignupSurvey'
import FeedbackModal from '@/components/Modals/FeedbackSurvey'
import CategoriesModal from '@/components/Modals/Categories'
import Logout from '@/components/Modals/Logout'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import link from '@/mixins/link'
import debounce from 'lodash/debounce'

export default {
  components: {
    Explore,
    Notifications,
    LoginModal,
    SourceModal,
    Logout,
    CategoriesModal,
    FeedbackModal
  },

  mixins: [auth, componentState, link],

  computed: {
    avatar: function () {
      return imageProxy.thumbnail(this.currentUser.avatar)
    },
    hasMail: function () {
      return this.mailCount > 0
    },
    mailCount: function () {
      return Math.min(this.$store.getters.unreadConversationsCount, 99)
    },
    hiddenMobile: function () {
      return this.$route.meta && (this.$route.meta.hideMobileNav === true)
    },
    active: function () {
      return true
    },
    showBackButton: function () {
      return this.$route.name === 'profile'
    },
    hideLogo: function () {
      return this.$route.query.iframe !== undefined
    },
    engComBranding: function () {
      return !this.$isProjects
    },
    logo: function () {
      return this.engComBranding ? '/static/logo-eng.svg' : '/static/logo-purple.svg'
    },
    wordmark: function () {
      return this.engComBranding ? '/static/wordmark-engcom-new.svg' : '/static/wordmark-new.svg'
    },
    logoAlt: function () {
      return this.engComBranding ? 'Engineering.com' : 'ProjectBoard'
    },
    showStartButton: function () {
      return this.userCanCreatePosts
    },
    searchPlaceholder: function () {
      return this.$isEngCom ? 'search stories and people' : 'search boards and people'
    },
    boardTypeLabel: function () {
      return this.$isEngCom ? 'Stories' : 'Boards'
    }
  },
  data: function () {
    return {
      showMenu: false,
      showLogout: false,
      isSearching: false,
      isHoverable: true,
      searchQuery: '',
      subscriptions: { message: false, user: false },
      checkedUnread: false,
      signupSource: 'LOGIN:{PATH}',
      navValue: null,
      passwordSet: false,
      isExploring: false
    }
  },
  mounted: function () {
    versionCheck.start()
    setTimeout(() => {
      this.checkIfLoggedIn()
    }, 10000)
  },
  destroyed: function () {
    versionCheck.stop()
  },
  updated: function () {
    if (this.isLoggedIn) {
      if (!this.subscriptions.user) {
        this.subscriptions.user = true
        socket.subscribeAll('user', this.currentUser.uuid)
      }
      if (!this.subscriptions.message) {
        this.subscriptions.message = true
        socket.subscribeAll('conversation', '')
      }
      if (!this.checkedUnread) {
        this.checkedUnread = true
        this.$store.dispatch('getUnreadCount', this.currentUser.userName).catch(() => {
          this.checkedUnread = false
        })
      }
    }
  },
  methods: {
    openLink (url, keepOpen = false, refresh = false) {
      // prevent logged out users from clicking profile
      if (!this.isLoggedIn && url === '/profile') {
        return
      }
      this.link(url, refresh)
      this.showMenu = false
      this.showLogout = false
      this.isSearching = false
      if (!keepOpen) {
        // hides dropdown and makes it hoverable again
        this.isHoverable = false
        setTimeout(() => {
          this.isHoverable = true
        }, 300)
      }
    },
    startNow: debounce(function () {
      this.$router.push({ path: '/qaStartButtonTemplate' })
    }),
    search: function () {
      if (this.searchQuery !== '') {
        const trimmedQuery = this.searchQuery.trim()
        this.$router.push({ name: 'search', query: { r: this.refreshKey() }, params: { searchQuery: trimmedQuery } })
        this.isSearching = false
        this.searchQuery = ''
      }
    },
    toggleExplore: function () {
      this.isExploring = !this.isExploring
    },
    toggleSearch: function () {
      this.isSearching = !this.isSearching
      this.showMenu = false
      if (this.isSearching) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    toggleMenu: function () {
      this.showMenu = !this.showMenu
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    showSignup: function (source) {
      if (!this.isLoggedIn) {
        this.passwordSet = false
        this.$store.dispatch('showLoginModal', { source })
      }
    },
    checkIfLoggedIn: function () {
      if (this.$isApp && !this.isLoggedIn) {
        this.showSignup()
      } else {
        this.libs.auth.checkLogin().then((loggedIn) => {
          if (this.shouldRedirectToAbout(loggedIn)) {
            this.$router.push({ name: 'about' })
          }
        })
      }
    },
    setNavValue: function (value) {
      this._set('navValue', value)
    },
    passwordSetComplete: function () {
      this.passwordSet = true
    },
    goBack: function () {
      if (window.history.length < 2) {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.go(-1)
      }
    },
    shouldRedirectToAbout: function (loggedIn) {
      return false
    },
    logout: function () {
      this.subscriptions = { message: false, user: false }
      this.checkedUnread = false
      this.passwordSet = false
      this.openLink('/logout')
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $tile-height: 52px;
  $tile-width: 61px; // 61px is hard-coded below inside of a calc()
  $tile-width-m: 52px;
  $tile-width-xl: 75px; //For the sign in button
  $tile-width-m-xl: 70px; // For the sign in button on mobile

/* General */
  .return {
    margin-left: 1rem;
    font-size:  0.9rem;
  }

  .navbar-container{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 15;
    border-bottom: solid 1px whitesmoke;
  }

  .navbar {
    max-height: $tile-height;
    z-index: inherit;
    background: white;
    opacity: 0.95;
    @include mobile {
      height: $tile-height;
      min-height: $tile-height;
    }
  }

  .navbar-title {
    z-index: 16;
    pointer-events: none;
    top: 1rem;
    width: 100%;
    position: absolute;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
    color: #7a7a7a;

    a {
      display: inline-block;
      pointer-events: auto;
      position: relative;
      &:hover {
        opacity: 0.8;
      }
    }

    .logo {
      position: relative;
      width: auto;
      max-width: 1.75rem;
      max-height: 1.75rem;
      position: relative;
      vertical-align: top;
      margin-top: -0.25rem;
      @include mobile {
        height: 20px;
        margin-top: 0;
      }
    }

    .wordmark {
      display: inline-block;
      width: 192px;
      height: 27px;
      margin-top: -0.15rem;
      margin-left: 0.1rem;

      @include mobile {
        display: none;
      }

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &.is-eng {
      .wordmark {
        width: 308px;
        height: 40px;
        margin-top: -0.55rem;
        margin-left: 0;
      }

      .logo {
        @include mobile {
         height: 25px;
         margin-top: -0.2rem;
        }
      }
    }
  }

  .navbar-item {
    @include mobile {
      height: $tile-height;
    }
  }

  .profile-img {
    width: 28px;
    height: 28px;
    @include mobile {
      width: 20px;
      height: 20px;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

/* //General// */

/* Search Bar */

  .search-bar {
    z-index: 16;
    position: absolute;
    top: 0;
    height: $tile-height;
    width: calc(100% - 122px);
    @include mobile {
      height: $tile-height;
    }
  }

  .search-bar.logged-out{
    width: calc(100% - 170px);
    @include mobile{
      width: calc(100% - 145px);
    }
  }

// Makes only the placeholders italics, but must be defined seperaltely

  ::-webkit-input-placeholder {
    font-style: italic;
  }
  :-moz-placeholder {
    font-style: italic;
  }
  ::-moz-placeholder {
    font-style: italic;
  }
  :-ms-input-placeholder {
    font-style: italic;
  }

  .search-field {
    position: absolute;
    right: 0;
    top: 0;
    width: calc(100% - 12vw);
    height: 100%;
    font-size: 1.3rem;
    border: none;
    border-left: 1px solid whitesmoke;
    padding-left: 3rem;
    @include mobile {
      left: 0;
      padding-left: 1rem;
      font-size: 1rem;
      width: 100%;
    }
  }

  .explore {
    font-size: 1.3rem;
  }

  .search-field:focus {
    outline: none;
  }

  .search {
    font-size: 0.9rem;
    position: relative;
    top: 1px;
  }

/* //Search Bar// */

/* Brand & Burgers */

  .navbar-brand {
    @include mobile {
      min-height: $tile-height;
    }
    .navbar-item {
      @include mobile {
        padding-right: 0;
      }
    }
  }

  .explore-button {
    margin-right: 0.5rem;
    margin-left: 1rem;
  }

  .start-now {
    display: flex;
    margin: 0;
    padding: 0;
    a {
      @include mobile {
        font-size: 0.7rem;
      }
    }
  }

  .navbar-burger {
    margin-left: none;
    @include touch {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @include mobile {
      height: $tile-height;
      width: $tile-width-m;
    }
  }
  .navbar-burger.logged-out {
    &.login {
      width: $tile-width-m-xl;
    }
    .navbar-item {
      padding: 0;
      padding-right: 0.2rem;
    }
  }
  .navbar-item.desktop-signin{
    @include mobile{
      display: none; //weird appearing button fix
    }

    .navbar-item:hover {
      background: none;
    }
  }

  .burger-group {
    display: flex;
    margin-left: auto;
  }

  .icon-burger {
    border-left: 1px solid whitesmoke;
  }
  .icon-burger.logged-out {
    border-left: 0;
  }

/* //Brand & Burgers// */

/* Menu & Dropdowns */

  .navbar-menu {
    position: relative;
    z-index: 1;
    @include touch {
      padding-top: 0;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .navbar-end, .navbar-menu {
    @include touch {
      position: absolute;
      right: 0;
    }
  }

  .is-seen {
    @extend .navbar-end;
    min-width: 150px;
    border: 1px solid whitesmoke;
    outline: none;
    @include touch {
      display: block;
      flex-direction: column;
      left: auto;
      right: 0;
      background-color: white;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      font-size: 0.875rem;
      // min-width: 100%;
      position: absolute;
      top: 100%;
      z-index: 15;
    }
  }

  .is-seen .navbar-item, .navbar-burger.is-active .navbar-item {
    display: block;
    @include touch {
      height: 35px;
    }
  }

  .custom-dropdown {
    width: $tile-width;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background-color: whitesmoke;
    }
  }
  .custom-dropdown.logged-out{
    width: $tile-width-xl;
    @include mobile{
      width: $tile-width-m-xl;
    }
  }

/* //Menu & Dropdowns// */

  /* Mail */

  .mail-icon, .mail-icon-mobile {
    align-items: center;
    justify-content: center;
    height: 52px;
    width: 52px;
    position: relative;
    top: 1px;
    &:hover {
      background-color: whitesmoke;
    }
  }
  .u-got-mail{
    color: $primary;
    font-weight: bold;
  }
  .unread-count{
    justify-content: center;
    align-items: center;
    font-size: 0.6rem;
    border: 1px solid $primary;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background-color: $primary;
    color: white;
    position: absolute;
    bottom: 9px;
    right: 8px;
  }

  @media (min-width: 1088px){
    .mail-icon-mobile{
      display: none;
    }
  }

  /* Start Now */
  .start-now {
    background: linear-gradient(to right, $secondary, $primary);
    font-size: 1rem;
    padding: 0 0.75rem;
    color: $white;
    border: none;
    @include tablet {
      span {
        width: 60px;
      }
    }
    @include mobile {
      height: 2rem;
    }
  }

  .navbar-brand {
    .back-button-top {
      cursor: pointer;
      padding-right: 0.5rem;
      padding-left: 0.4rem;
      margin-right: 0;
      @include mobile {
        margin-right: 0;
        width: 1.5rem;
      }
    }
    .start-now {
      @include mobile {
        padding: 0 0.75rem;
        font-size: 0.8rem;
      }
    }
  }
  /* //Start Now// */

  .navbar-dropdown {
    width: 160px;
    @include mobile {
      margin-top: -$navbar-height;
    }

    .navbar-item {
      font-size: 0.8rem;
      .icon .fa {
        font-size: 0.8rem;
      }
    }
  }

  .navbar-spacer {
    height: $navbar-height;
  }

  .hidden-mobile {
    @include touch {
      display: none;
    }
  }

  .small-start .start-now{
    font-size: 0.7rem;
    padding: 0;
    margin-left: 0;
    min-width: 3.5rem;
  }

  .how-to-wrapper {
    align-items: left;
    margin-left: 1rem;
  }
  // custom screen for iPhone 5/SE sizes
  @media screen and (max-width: 375px) {
    .navbar-burger {
      width: 45px;
    }
    .u-got-mail {
      padding-left: 0;
    }
    .unread-count {
      bottom: 8px;
      right: 3px;
    }
  }
</style>
